export default __webpack_public_path__ + "static/media/nova-logo-caixa.8520f767.svg";